window.addEventListener('load', ()=>{
    tabs();
});

const block = document.querySelector('.tabs-block');

function tabs() {
    const tabsNav = block.querySelectorAll('.tabs-nav .nav-element');
    const tabsElements = block.querySelectorAll('.contents-wrapper .content');

    tabsNav.forEach((nav, id) => {
        nav.addEventListener('click', ()=>{
            tabsNav.forEach(element => {
                element.classList.remove('active');
            });
            tabsElements.forEach(element => {
                element.classList.remove('active');
            });
            tabsElements[id].classList.add('active');
            nav.classList.add('active');
        })
    });
}
